//Core modules
import React, {useEffect, useState} from "react";

//External modules
import {Button} from "reactstrap";

//Internal modules
import {
    currencyFormatter,
    getOrganizationInfo,
    handleErrorResponse,
    showToast
} from "../../../Common/Appcommon";
import ListTable from "../../../Common/ListTable";
import {useSettingsContext} from "../context/settingsContext";
import requestApi from "../../../services/requestApi.service";

const CustomCharges = () => {

    const [customCharges, setCustomCharges] = useState({});

    const { setShowLoader } = useSettingsContext();

    const formname = process.env.REACT_APP_CUSTOMCHARGES_FORMNAME;

    useEffect(()=>{
        (async ()=>{
            await getCustomCharges();
        })();
    },[])

    const getCustomCharges = async () => {

        let params = {
            "ENTITY": "razorpay",
            "OPERATION" : 'GET_CUSTOMIZATION_CHARGES'
        }
        let response = await requestApi.processServerRequest(params);

        if(response.issuccess){
            if(response.data){
                const data = response.data;
                setCustomCharges({...data});
            }
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const handlePayment = async (formData) => {

        const amount = formData[`Amount`];

        if(amount !== "" && amount != null && amount > 0){

            setShowLoader(true);
            const orderInfo = await createOrder(amount);
            setShowLoader(false);

            if(orderInfo.length > 0){

                const orgInfo = getOrganizationInfo();

                let customerName = "";
                let customerMobile = "";
                let customerEmail = "";

                if(orgInfo && Object.keys(orgInfo).length > 0){
                    customerName = orgInfo[1] ? orgInfo[1] : "";
                    customerMobile = orgInfo[5] ? orgInfo[5] : "";
                    customerEmail = orgInfo[4] ? orgInfo[4] : "";
                }

                    const options = {
                        key: process.env.RAZOR_PAY_KEY_ID,
                        order_id : orderInfo[0],
                        amount : orderInfo[1],
                        description : "Order ID: " + orderInfo[0],
                        name: "Cratio Payment",
                        image : "https://cratiocrm.com/wp-content/uploads/2022/12/logo-1024x248.png",
                        handler: async (response) => {
                            try {
                                await capturePayment(response,formData);
                            } catch (err) {
                                console.log(err);
                            }
                        },
                        prefill : {
                            "name" : customerName,
                            "email" : customerEmail,
                            "contact" : customerMobile,
                        },
                        theme: {
                            color: "#0066cc",
                        },
                        modal : {
                            ondismiss : function(response) {
                                //showToast(`Payment Cancelled...`,`top-right`,`warning`);
                            }
                        }
                    };

                    const rzp1 = new window.Razorpay(options);
                    rzp1.open();

            }else{
                handleErrorResponse(`unable to proceed.`);
            }
        }
    }

    const createOrder = async (amount) => {

        let order = [];
        const params = {
            "ENTITY": "razorpay",
            "OPERATION": "createorder",
            "totalamount": amount
        };

        let response = await requestApi.processServerRequest(params,'WebV2','post');
        if(response.issuccess){
            order = response.data;
        }else{
            handleErrorResponse(response.errormsg);
        }

        return order;
    }

    const capturePayment = async (res,formData) => {

        const paymentId = res.razorpay_payment_id;
        const orderId = res.razorpay_order_id;
        const formId = formData['Id'];
        const amount = formData['Amount'];

        const params = {
            "ENTITY": "razorpay",
            "OPERATION": "capturecustompayment",
            "paymentid": paymentId,
            "orderid": paymentId,
            "formid": formId,
            "amount" : amount
        };

        setShowLoader(true);
        let response = await requestApi.processServerRequest(params,'WebV2','post');
        setShowLoader(false);

        if(response.issuccess){
            const data = response.data;
            if(data[0] === 'success'){
                showToast(`Payment successful.`);
            }else{
                showToast(`Something went wrong.`,`top-right`,`error`);
            }
            await getCustomCharges();
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const renderElements = (name,formData) => {

        if(name === 'Pay'){
            return (
                <div className={`text-left`}>
                    <Button onClick={()=>handlePayment(formData)} className="m-1 me-2 btn-icon le-button lePrimaryBtn btn btn-success">
                        Pay
                    </Button>
                </div>
            )
        }else if(name === 'Amount'){

            const amount = formData['Amount'];

            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={` template-primary `}>{amount ? currencyFormatter('en-IN', 'INR', amount,0) : currencyFormatter('en-IN', 'INR', amount,0)}</span>
                    </div>
                </>
            )
        }
    }

    let formData = [];

    let listFields = [
        ['Description','Amount','Status','Pay'],
        ['Description','Amount','Status','Pay']
    ];

    for(let i=0; i< Object.keys(customCharges).length;i++){
        formData[i] = [];
        formData[i]['Id'] = customCharges[i][`${formname}_id`];
        formData[i]['Description'] = customCharges[i].Description;
        formData[i]['Amount'] = customCharges[i].Amount;
        formData[i]['Status'] = customCharges[i].Status;
        formData[i]['Pay'] = '0';
    }

    let headerFieldConfig = {
        Description : {
            "class" : "text-left"
        },
        Amount : {
            "class" : "text-left"
        },
        Status : {
            "class" : "text-left"
        },
        Pay : {
            "class" : "text-left"
        }
    };

    let customFieldConfig = {
        Description : {
            "class" : "text-left"
        },
        Amount : {
            "render" : "Amount",
            "class" : "text-left"
        },
        Status : {
            "class" : "text-left"
        },
        Pay : {
            "render" : "Pay",
            "class" : "text-left"
        }
    };

    return (
        <>
            {
                formData.length > 0 &&
                <div className={`mb-5`}>
                    <div className={`mb-2 mt-3`}>
                        <span className={'screen-header-text mx-12'}>{`Pending Charges`}</span>
                    </div>
                    <ListTable
                        key={Math.random()}
                        aliasIndex={'0'}
                        labelIndex={'1'}
                        formData={formData}
                        fields={listFields}
                        headerConfig={headerFieldConfig}
                        config={customFieldConfig}
                        showRowCount={true}
                        renderElements={renderElements}
                        noDataMsg={`Custom Charges not found`}
                        customClass={'no-border-table'}
                        prefix = {"customcharges"}
                    />
                </div>
            }

        </>
    );

}

export default CustomCharges;